const NAME = "RATINGS";

export default NAME;
